export default class ageGate {
  
  
  constructor() {
    agegate = document.getElementById("agegate");
  }
  
  static init() {
    this.ageCheck();
  }
  
  static ageCheck() {
    
    var _uid = 'coastalcocktails';
    var _localStorage = false;
    
    /* HACK -- LS Check */
    if (typeof localStorage === 'object') {
      try {
        localStorage.setItem(_uid + '_localStorage', 1);
        localStorage.removeItem(_uid + '_localStorage');
        _localStorage = true;
      }
      catch (e) {
        console.log('LS not supported due to Private Browsing mode.');
        _localStorage = false;
      }
    }
    
    if (_localStorage) {
      // Fake Cookie
      var COOKIE = '_' + _uid + '_agecheck';
      var hours = 24; // Reset when storage is more than 24hours
      var now = new Date().getTime();
      var setupTime = localStorage.getItem(COOKIE);
      
      if (setupTime == null) {
        console.log('if')
        // localStorage.setItem(COOKIE, now);
        jQuery('#agegate').removeClass('hidden');
      }
      else {
        if ((now - setupTime) > hours * 60 * 60 * 1000) {
          console.log('else if') 
          localStorage.removeItem(COOKIE);
          localStorage.setItem(COOKIE, now);
          jQuery('#agegate').removeClass('hidden');
        }
      }
      
      // Age Check Confirm
      jQuery(document).on('click', '#agegate .confirm', function () {
        var now = new Date().getTime();
        localStorage.setItem(COOKIE, now);
        jQuery('#agegate').fadeOut(400, function () {
          jQuery('#agegate').addClass('hidden');
        });
      });

      // Age Check Deny
      jQuery(document).on('click', '#agegate .deny', function () {
        jQuery('.deny-text').fadeIn(240);
      });
      
    }
    
  }
}